import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Carousel from './components/Carousel';
import { fetchCourseCategory, fetchAccess } from './Api';
import LectureCard from './components/CourseCard';

const Home = () => {
  const [lectures, setLectures] = useState([]);
  const [accessMap, setAccessMap] = useState({});
  const [loadingAccess, setLoadingAccess] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const loadLectures = async () => {
      const data = await fetchCourseCategory();
      // console.log('Lectures fetched:', data);
      if (Array.isArray(data)) setLectures(data);
      else console.error("Failed to fetch lectures.");
    };

    const loadAccess = async () => {
      const uid = localStorage.getItem('loggedInUserId');
      // console.log('UID from localStorage:', uid);
      if (!uid) {
        console.warn('User not logged in');
        setLoadingAccess(false);
        return;
      }

      const response = await fetchAccess(uid);
      // console.log('Raw access response:', response);

      if (response.status === 200 && Array.isArray(response.data)) {
        const map = {};
        response.data.forEach((item) => {
          // console.log('Access record:', item);
          const category = item.course_category?.trim();
          const giveAccess = parseInt(item.giveAccess);
          // console.log(`Category: "${category}", Access: ${giveAccess}`);

          if (giveAccess === 1) {
            map[category] = true;
          }
        });
        // console.log('Final accessMap:', map);
        setAccessMap(map);
      } else {
        console.warn('No access data found.');
      }

      setLoadingAccess(false);
    };

    loadLectures();
    loadAccess();
  }, []);

  // Disable right-click and common inspect shortcuts
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
  
    const handleKeyDown = (e) => {
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) && 
        (e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key.toUpperCase()))
      ) {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) &&
        ['U', 'S', 'P'].includes(e.key.toUpperCase())
      ) {
        e.preventDefault();
        return false;
      }
    };
  
    window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter lectures by searchTerm on the category field
  const filteredLectures = lectures.filter((lecture) => {
    // console.log('Filtering lecture:', lecture);
    return lecture.category?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  // Split lectures into "accessible" and "non-accessible"
  const accessibleLectures = filteredLectures.filter(
    (lecture) => accessMap[lecture.category]
  );

  const nonAccessibleLectures = filteredLectures.filter(
    (lecture) => !accessMap[lecture.category]
  );

  return (
    <>
      <Header />
      <div className="container my-5">
      <Carousel />
        {/* <div className="text-center mb-4">
          <h1>Welcome to the Video Learning Platform</h1>
          <p>Explore our available resources below.</p>
        </div> */}
        <div className="d-flex justify-content-center my-4 mb-4">
          <input
            type="text"
            className="form-control form-control-lg w-100 shadow-sm rounded-pill"
            placeholder="🔍 Search by course..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {/* Accessible Courses */}
        {accessibleLectures.length > 0 && (
          <>
            <h2 className="mb-4">Your Learnings</h2>
            <div className="row">
              {accessibleLectures.map((lecture) => (
                <LectureCard
                  key={lecture.id}
                  lecture={lecture}
                  hasAccess={true}
                  loadingAccess={loadingAccess}
                />
              ))}
            </div>
          </>
        )}

        {/* Non-Accessible Courses */}
        {nonAccessibleLectures.length > 0 && (
          <>
            <h2 className="mb-4 mt-5">Recommended Courses</h2>
            <div className="row">
              {nonAccessibleLectures.map((lecture) => (
                <LectureCard
                  key={lecture.id}
                  lecture={lecture}
                  hasAccess={false}
                  loadingAccess={loadingAccess}
                />
              ))}
            </div>
          </>
        )}

        {/* Fallback when no courses match */}
        {accessibleLectures.length === 0 && nonAccessibleLectures.length === 0 && (
          <div className="text-center text-danger">No Course found.</div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Home;
